import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { schools, staff } from "../domain/data";
import { useMail } from "../state/MailProvider";
import { PrototypeBanner, StaffNav } from "../components/ui";

export function StaffSettings() {
  const { settings, saveSettings } = useMail();
  const [centralEmail, setCentralEmail] = useState(settings.centralEmail);
  const [usePerSchool, setUsePerSchool] = useState(settings.usePerSchool);
  const [schoolEmails, setSchoolEmails] = useState(settings.schoolEmails);
  const [saved, setSaved] = useState(false);

  function onSubmit(event: FormEvent) {
    event.preventDefault();
    saveSettings({ centralEmail, usePerSchool, schoolEmails });
    setSaved(true);
  }

  return (
    <div className="app">
      <PrototypeBanner />
      <main className="shell">
        <StaffNav />
        <p className="meta">
          Staff · {staff.given} {staff.family} · settings
        </p>
        <h1>Notification settings</h1>
        <p className="lede">
          When a family files this year's form, adds a child, or a student
          registers for an event, Lift emails the guardian and this inbox.
          systems@liftteencenter.com always receives a copy. You can also notify
          each school's coordinator. Copies stay in the registration inbox.
          Production sends them once outbound email is turned on.
        </p>

        <form className="stack" onSubmit={onSubmit}>
          <div className="field">
            <label htmlFor="central-email">Central inbox</label>
            <input
              id="central-email"
              type="email"
              value={centralEmail}
              onChange={(e) => {
                setCentralEmail(e.target.value);
                setSaved(false);
              }}
            />
            <div className="anno">
              systems@liftteencenter.com receives these notes along with this
              address.
            </div>
          </div>

          <label className="checks">
            <input
              type="checkbox"
              checked={usePerSchool}
              onChange={(e) => {
                setUsePerSchool(e.target.checked);
                setSaved(false);
              }}
            />
            Also email the school coordinator
          </label>

          {usePerSchool
            ? schools.map((school) => (
                <div className="field" key={school}>
                  <label htmlFor={`school-${school}`}>{school}</label>
                  <input
                    id={`school-${school}`}
                    type="email"
                    value={schoolEmails[school]}
                    onChange={(e) => {
                      const value = e.target.value;
                      setSchoolEmails((current) => ({
                        ...current,
                        [school]: value,
                      }));
                      setSaved(false);
                    }}
                  />
                </div>
              ))
            : null}

          {saved ? (
            <div className="flash flash--success" role="status">
              Settings saved for this browser.
            </div>
          ) : null}

          <div className="actions">
            <button type="submit">Save settings</button>
            <Link className="btn ghost" to="/staff/inbox">
              Open inbox
            </Link>
          </div>
        </form>
      </main>
    </div>
  );
}
